import { Node, mergeAttributes } from '@tiptap/core'
import { VueNodeViewRenderer } from '@tiptap/vue-2'
import Component from './RegionNode.vue'
import { Plugin, PluginKey } from 'prosemirror-state'


export default Node.create({
  name: 'region',

  group: 'block',
  selectable: false,
  content: '(line+ | table+)',  

  addAttributes() {
    return {
      lines: {
        default: [],
      },
      number: {
        default: 0,
      },
    }
  },
  addProseMirrorPlugins() {
    return [
      new Plugin({
        props: {
          handleKeyDown: (view, event) => {
            if (event.which === 8 || event.which === 46) {
              view.state.deleting = true
            }
            return false
          }
        },

        filterTransaction: (transaction, state) => {
          if (!state.deleting) {
            return true
          }

          var result = true
          let count = 0
          transaction.mapping.maps.forEach(map => {
            map.forEach((oldStart, oldEnd, newStart, newEnd) => {
              state.doc.nodesBetween(
                oldStart,
                oldEnd,
                (node, number, pos, parent, index) => {
                  if (node.type.name === 'region') {
                    count++
                  }
                }
              )
            })
          })
          if (count > 1) {
            result = false
          }
          return result
        }
      })
    ]
  },

  parseHTML() {
    return [
      {
        tag: 'div',
      },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return ['div', mergeAttributes(HTMLAttributes)]
  },

  addNodeView() {
    return VueNodeViewRenderer(Component)
  },
})